<template>
  <div>
    <sr-header></sr-header>
    <section class="home-container clearfix">
      <router-view/>
      <div class="footer">©{{year}} Sunrate All rights reserved 沪ICP备16009386号 沪公网安备 31011502002512号</div>
    </section>
  </div>
</template>

<script setup>
import SrHeader from './login-header'
import { ref } from 'vue'
const year = ref(new Date().getFullYear())
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .home-container {
    width: 100%;
    margin: 0 auto;
    /*height: calc(100vh - 53px);*/
    display: flex;
    align-items: center;
    flex-direction: column;
    position: sticky;
    min-height: calc(100vh - 53px);

    .footer {
      width: 100%;
      padding: 50px 50px;
      position: absolute;
      bottom: 0;
      text-align: center;
    }
  }

  @media screen and (min-width: 621px) {
    .home-container {
      background: url('../assets/img/login_bg.png') 0 0 no-repeat;
      background-size: cover;

      .footer {
        padding: 50px 20px;
        color: #fff;
      }
    }
  }

  @media screen and (max-width: 620px) {
    .home-container {
      background-color: #fff;

      .footer {
        color: #999;
        padding: 0 50px 50px;
      }
    }
  }
</style>
